export default class Customer{
    constructor(
        public name: string,
        public emails: string,
        public emailsCC: string,
        public emailTitle: string,
        public emailBody: string,
        public lead: string,
        public includeJobs: boolean,
        public includeKeywords: boolean,
        public topics: Topic[] = [],
        public interval: string,
        public sorting: string,
    ){}
}

export class Topic{
    constructor(public name: string= "", public keywords: string[] = []){};
}